// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Visualize that we can click on an event with tippy content */
a.fc-event[data-tippy-content],
td.fc-list-event-title a[data-tippy-content] {
  cursor: pointer;
}

/* Not sure what this does... */
.pgc-calendar-wrapper *,
.pgc-calendar-wrapper *::before,
.pgc-calendar-wrapper *::after {
  word-break: initial;
}

/**********************************
 * Start calendar filter checkboxes
 **********************************/
.pgc-calendar-filter input[type=checkbox]:focus+label span,
.pgc-calendar-filter input[type=checkbox]:active+label span {
  outline: 1px dashed black;
}

.pgc-calendar-filter input[type=checkbox] {
  opacity: 0;
  position: fixed;
  /* absolute makes the page scroll to top when checked */
}

.pgc-calendar-color {
  width: 1.4rem;
  height: 1.4rem;
  padding: 0 .2rem;
  opacity: .4;
}

.pgc-calendar-filter input[type=checkbox]+label {
  margin: 0 1rem 0 0;
  padding: 0;
}

.pgc-calendar-filter input[type=checkbox]:checked+label span {
  opacity: 1;
}

.pgc-calendar-filter input[type=checkbox]+label span:before {
  content: "✔";
  line-height: 1.4rem;
  visibility: hidden;
}

.pgc-calendar-filter input[type=checkbox]:checked+label span:before {
  visibility: visible;
}

.pgc-calendar-filter:first-child {
  margin-bottom: 1rem;
}

.pgc-calendar-filter:last-child {
  margin-top: 1rem;
}

/* End calendar filter checkboxes */



/*****************************************************
 * Start tippy content basic styling
 * This can be overruled or detailed in a custom theme
 *****************************************************/
.tippy-content {
  padding: 1rem;
}

.pgc-event-title {
  font-size: large;
  font-weight: 500;
}

.pgc-popup-row-icon {
  width: 2rem;
  float: left;
}

.pgc-popup-row-value {
  margin-left: 2rem;
}

.pgc-event-title .pgc-popup-row-value {
  margin-right: 3rem;
  margin-left: 0;
}

.pgc-popup-row {
  clear: both;
  margin-bottom: 1rem;
}

.pgc-popup-row ul,
.pgc-popup-row li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pgc-popup-draghandle {
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: move;
  opacity: .4;
}

/* End tippy content basic styling */

/*************************
 * Start loading and error
 *************************/

.pgc-loading-el,
.pgc-error-el {
  position: absolute;
  background-color: #fcf8e3;
  padding: 1rem;
  left: 0;
  top: 0;
  opacity: .8;
  z-index: 1000;
}

.pgc-error-el {
  background-color: red;
  opacity: 1;
}

/*********************************************************************
 * On small screens the title and buttons need to get below each other
 *********************************************************************/
@media(max-width:649px) {
  .fc .fc-toolbar.fc-header-toolbar {
    margin-bottom: .6rem;
  }

  .fc .fc-toolbar {
    display: block;
  }

  .fc-toolbar-chunk {
    display: block;
    text-align: center;
  }

  .fc-toolbar>div {
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;;EAEE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;;EAGE,mBAAmB;AACrB;;AAEA;;mCAEmC;AACnC;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;;;;AAInC;;;sDAGsD;AACtD;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA,oCAAoC;;AAEpC;;0BAE0B;;AAE1B;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;;sEAEsE;AACtE;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Visualize that we can click on an event with tippy content */\na.fc-event[data-tippy-content],\ntd.fc-list-event-title a[data-tippy-content] {\n  cursor: pointer;\n}\n\n/* Not sure what this does... */\n.pgc-calendar-wrapper *,\n.pgc-calendar-wrapper *::before,\n.pgc-calendar-wrapper *::after {\n  word-break: initial;\n}\n\n/**********************************\n * Start calendar filter checkboxes\n **********************************/\n.pgc-calendar-filter input[type=checkbox]:focus+label span,\n.pgc-calendar-filter input[type=checkbox]:active+label span {\n  outline: 1px dashed black;\n}\n\n.pgc-calendar-filter input[type=checkbox] {\n  opacity: 0;\n  position: fixed;\n  /* absolute makes the page scroll to top when checked */\n}\n\n.pgc-calendar-color {\n  width: 1.4rem;\n  height: 1.4rem;\n  padding: 0 .2rem;\n  opacity: .4;\n}\n\n.pgc-calendar-filter input[type=checkbox]+label {\n  margin: 0 1rem 0 0;\n  padding: 0;\n}\n\n.pgc-calendar-filter input[type=checkbox]:checked+label span {\n  opacity: 1;\n}\n\n.pgc-calendar-filter input[type=checkbox]+label span:before {\n  content: \"✔\";\n  line-height: 1.4rem;\n  visibility: hidden;\n}\n\n.pgc-calendar-filter input[type=checkbox]:checked+label span:before {\n  visibility: visible;\n}\n\n.pgc-calendar-filter:first-child {\n  margin-bottom: 1rem;\n}\n\n.pgc-calendar-filter:last-child {\n  margin-top: 1rem;\n}\n\n/* End calendar filter checkboxes */\n\n\n\n/*****************************************************\n * Start tippy content basic styling\n * This can be overruled or detailed in a custom theme\n *****************************************************/\n.tippy-content {\n  padding: 1rem;\n}\n\n.pgc-event-title {\n  font-size: large;\n  font-weight: 500;\n}\n\n.pgc-popup-row-icon {\n  width: 2rem;\n  float: left;\n}\n\n.pgc-popup-row-value {\n  margin-left: 2rem;\n}\n\n.pgc-event-title .pgc-popup-row-value {\n  margin-right: 3rem;\n  margin-left: 0;\n}\n\n.pgc-popup-row {\n  clear: both;\n  margin-bottom: 1rem;\n}\n\n.pgc-popup-row ul,\n.pgc-popup-row li {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.pgc-popup-draghandle {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  cursor: move;\n  opacity: .4;\n}\n\n/* End tippy content basic styling */\n\n/*************************\n * Start loading and error\n *************************/\n\n.pgc-loading-el,\n.pgc-error-el {\n  position: absolute;\n  background-color: #fcf8e3;\n  padding: 1rem;\n  left: 0;\n  top: 0;\n  opacity: .8;\n  z-index: 1000;\n}\n\n.pgc-error-el {\n  background-color: red;\n  opacity: 1;\n}\n\n/*********************************************************************\n * On small screens the title and buttons need to get below each other\n *********************************************************************/\n@media(max-width:649px) {\n  .fc .fc-toolbar.fc-header-toolbar {\n    margin-bottom: .6rem;\n  }\n\n  .fc .fc-toolbar {\n    display: block;\n  }\n\n  .fc-toolbar-chunk {\n    display: block;\n    text-align: center;\n  }\n\n  .fc-toolbar>div {\n    margin-bottom: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
